import Cookies from 'js-cookie'
import { storeToRefs } from 'pinia'
import { z } from 'zod'
import { RouterName } from '@/enums/router-name'
import { corporateAccountUserProfileSchema } from '@/models/api/corporate-account-user-profile'
import { userProfileSchema } from '@/models/api/user-profile'
import { api } from '@/services'
import { useIdentityStore } from '@/stores/use-identity-store'
import { useOtpStore } from '@/stores/use-otp-store'
import { useUserStore } from '@/stores/use-user-store'
import { isLoading } from '@/utils/functions/is-loading'
import { CookiesKey } from '@library/enums/cookies-key'
import { useStorage } from '~library/composables'
import { Identity, LocalStorage } from '~library/enums'
import { isApiSuccess } from '~library/utils/functions'
import { useRouterUtils } from './use-router-utils'
import { usePage } from './use-page'

export function useAuth() {
  const { setIdentity } = useIdentityStore()
  const { isTraveler } = storeToRefs(useIdentityStore())
  const { setCorporateAccount, setUserProfile } = useUserStore()
  const { userProfile } = storeToRefs(useUserStore())
  const { defaultOtpData } = useOtpStore()
  const router = useRouterUtils()
  const { checkIsJoinUsPage } = usePage()

  const { getStorageData } = useStorage()

  /** 登出 */
  const logout = async (callLogout = true) => {
    const isSuccess =
      callLogout === false ||
      isApiSuccess(await isLoading(api.loginAuth.logout()))

    if (isSuccess) {
      defaultOtpData()
      setIdentity(null)
      setUserProfile(null)
      Cookies.remove(CookiesKey.S_MEMBER)

      if (!checkIsJoinUsPage()) {
        router.push({
          name: RouterName.HOME
        })
      }
    }
  }

  /** 初始化登入資料 */
  const initAuthData = () => {
    const userProfileData = getStorageData({
      key: LocalStorage.USER_PROFILE,
      zodSchema: z.union([userProfileSchema, corporateAccountUserProfileSchema])
    })

    const identity = getStorageData({
      key: LocalStorage.USER_PROFILE_IDENTITY,
      zodSchema: z.nativeEnum(Identity)
    })

    const corporateAccount = getStorageData({
      key: LocalStorage.CORPORATE_ACCOUNT,
      zodSchema: z.string()
    })

    if (userProfileData) {
      setUserProfile(userProfileData)
    }

    if (identity) {
      setIdentity(identity)
    }

    if (corporateAccount) {
      setCorporateAccount(corporateAccount)
    }
  }

  /**
   * 切換身份
   */
  const switchIdentity = () => {
    // 訪客或差旅人不可切換身份（直接返回）
    if (Number(userProfile.value?.identity ?? 0) < 2) {
      return
    }
    if (isTraveler?.value) {
      setIdentity(Identity.MAIN_MANAGER)
    } else {
      setIdentity(Identity.TRAVELER)
    }
    router.push({
      name: RouterName.HOME
    })
  }

  return { logout, switchIdentity, initAuthData }
}
